import { usePendingPicksCount } from '@/renderer/utils/hooks/usePendingPicksCount';

/**
 * Small "N pending" badge for the My Results nav item — the count of the
 * member's ungraded, non-future plays across all sports. Renders nothing when
 * there are none (or when logged out).
 *
 * The count is ghost-aware (see usePendingPicksCount): a fresh or returning
 * subscriber with no messageReceipts still sees a correct "N pending", and it
 * always matches the My Results pending section (same source, same filters).
 * Live-updates on new releases/grades are preserved by the shared hook (#1459).
 */
export function PendingCountBadge() {
  const { count, loggedIn } = usePendingPicksCount();

  if (!loggedIn || !count) {
    return null;
  }

  return (
    <span className="inline-flex h-3 w-3 shrink-0 items-center justify-center rounded-full bg-amber-400/90 px-3 py-2 text-xs font-medium leading-none text-zinc-900">
      {count}
    </span>
  );
}
